import React, { useState, useRef, useEffect } from "react";
import { createPortal } from "react-dom";
import "./TagsSuggestionDropdown.css";
import TagComponent from "./TagComponent";
import checkIcon from "../../assets/blackCheck.svg";
import { OrbitProgress } from "react-loading-indicators";
import { useDispatch } from "react-redux";
import toast from "react-hot-toast";
import { deleteTag } from "../../store/projectsSlice";
import useIsMobile from "../../hooks/useIsMobile";

const TagsSuggestionDropdown = ({
  tags,
  searchQuery,
  onSelect,
  selectedIndex,
  handleCreateTag,
  tagCreating,
  currentTagColor,
  tagsArray,
  colorsArray,
  setCurrentTagColor,
  tagsDefaultColors,
  updateTagsArray,
  onClose,
}) => {
  const [showColorPicker, setShowColorPicker] = useState(false);
  const colorButtonRef = useRef(null);
  const [hoveredItemId, setHoveredItemId] = useState(null);
  const isMobile = useIsMobile();
  const dispatch = useDispatch();
  const modalRef = useRef();
  const [colorPickerPosition, setColorPickerPosition] = useState({
    top: 0,
    left: 0,
  });

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (modalRef.current && !modalRef.current.contains(event.target)) {
        onClose();
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [onClose]);

  const handleColorSelect = (color) => {
    setCurrentTagColor(color);
    setShowColorPicker(false);
  };

  const updateColorPickerPosition = () => {
    if (colorButtonRef.current) {
      const rect = colorButtonRef.current.getBoundingClientRect();
      setColorPickerPosition({
        top: rect.top - 85,
        left: rect.left + rect.width / 2,
      });
    }
  };

  useEffect(() => {
    if (showColorPicker) {
      updateColorPickerPosition();
      window.addEventListener("resize", updateColorPickerPosition);
      window.addEventListener("scroll", updateColorPickerPosition);

      return () => {
        window.removeEventListener("resize", updateColorPickerPosition);
        window.removeEventListener("scroll", updateColorPickerPosition);
      };
    }
  }, [showColorPicker]);

  const onCLickDeleteTag = (tagId) => {
    if (confirm("Вы действительно хотите удалить тэг?")) {
      dispatch(deleteTag({ tagId })).then((res) => {
        if (!res.error) {
          updateTagsArray();
        } else {
          toast.error(res.payload.error || res.payload);
        }
      });
    }
  };

  const filteredTags = tagsArray.filter((tag) =>
    tag.name.toLowerCase().includes(searchQuery.toLowerCase())
  );

  return (
    <div
      className={
        isMobile
          ? "tags-suggestion-dropdown-mobile"
          : "tags-suggestion-dropdown"
      }
      // style={{ opacity: filteredTags.length > 0 ? 1 : 0 }}
      style={{
        background: filteredTags.length > 0 ? "#333b4b" : "transparent",
        boxShadow:
          filteredTags.length > 0 ? "0 4px 12px rgba(0, 0, 0, 0.15)" : "none",
      }}
      ref={modalRef}
    >
      {/* <div className="tags-top-line">
        <span className="tag-suggestion-title">Добавить тэг</span>
        <div className="tag-create-block">
          <span className="tag-new-name">
            {searchQuery ? `${searchQuery}` : ""}
          </span>
          <div className="tag-create-right-part">
            <div className="tag-new-color-choose">
              <div
                ref={colorButtonRef}
                style={{
                  width: 16,
                  height: 16,
                  borderRadius: 15,
                  backgroundColor: currentTagColor,
                }}
                onClick={() => setShowColorPicker(!showColorPicker)}
              ></div>
            </div>
            <div onClick={handleCreateTag} className="tag-new-create-button">
              {tagCreating ? (
                <OrbitProgress style={{ fontSize: 3 }} color={"black"} />
              ) : (
                <span style={{ fontSize: 24, fontWeight: 400 }}>+</span>
              )}
            </div>
          </div>
        </div>
      </div> */}
      <div className={isMobile ? "tags-list-mobile" : "tags-list"}>
        {filteredTags.map((tag, idx) => (
          <div
            style={{ position: "relative" }}
            onMouseEnter={() => setHoveredItemId(tag.id)}
            onMouseLeave={() => setHoveredItemId(null)}
          >
            <TagComponent
              tagsDefaultColors={tagsDefaultColors}
              key={tag.id}
              tag={tag}
              isSelected={selectedIndex === idx}
              onClick={() => onSelect(tag)}
            />
            {hoveredItemId === tag.id && (
              <div
                onClick={() => onCLickDeleteTag(tag.id)}
                style={{
                  position: "absolute",
                  top: -4,
                  right: -5,
                  width: 15,
                  height: 15,
                  border: "0px solid white",
                  backgroundColor: "rgba(31, 36, 46, 1)",
                  borderRadius: 10,
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  color: "white",
                  boxSizing: "border-box",
                  paddingBottom: 3,
                  fontSize: 10,
                  cursor: "pointer",
                }}
              >
                x
              </div>
            )}
          </div>
        ))}
      </div>

      {showColorPicker &&
        createPortal(
          <div
            className="color-picker-popup"
            style={{
              position: "fixed",
              top: colorPickerPosition.top,
              left: colorPickerPosition.left,
              transform: "translateX(-50%)",
            }}
          >
            {colorsArray.map((color, index) => (
              <div
                key={index}
                className="color-option"
                style={{ backgroundColor: color }}
                onClick={() => handleColorSelect(color)}
              />
            ))}
          </div>,
          document.body
        )}
    </div>
  );
};

export default TagsSuggestionDropdown;
